<template>
  <div class="pt-5">
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="dates"
        transition="scale-transition"
        offset-y
        min-width="310px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dates"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="dates"
          no-title
          scrollable
          range
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menu = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="selectRange"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DataPicker",

  data: () => ({
      dates: null,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
    }),

  computed: {
    ...mapGetters({
      datesrange: "datesrange",
    }),
  },

  methods: {
    selectRange(){
      this.$refs.menu.save(this.dates)
      this.$store.dispatch("setDatesRange", this.dates);
    }
  },

  mounted(){
    this.dates = this.datesrange
  },

}
</script>

<style>

</style>